import React from 'react';
import { cn } from '../../lib/utils';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-lg font-bold transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#F97316] text-white hover:bg-[#EA580C] shadow-lg hover:shadow-xl focus:ring-[#F97316]',
    secondary: 'bg-[#1B3A6B] text-white hover:bg-[#1E40AF] shadow-md hover:shadow-lg focus:ring-[#1B3A6B]',
    outline: 'border-2 border-[#1B3A6B] text-[#1B3A6B] hover:bg-[#EFF6FF] focus:ring-[#1B3A6B]',
    ghost: 'text-[#1B3A6B] hover:bg-[#EFF6FF] hover:text-[#1E40AF]'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl uppercase tracking-wide'
  };
  return <button className={cn(baseStyles, variants[variant], sizes[size], fullWidth ? 'w-full' : '', className)} {...props} data-id="element-203">
      {children}
    </button>;
}